import React from "react";
import PetImg from "../../assets/strider.webp";

const Info = () => {
  return (
    <div className="about__info grid">
      <div className="about__box">
        <i className="bx bx-award about__icon"></i>
        <h3 className="about__title">Experience</h3>
        <span className="about__subtitle">3+ Years</span>
      </div>

      <div className="about__box">
        <i className="bx bx-briefcase-alt about__icon"></i>
        <h3 className="about__title">Completed</h3>
        <span className="about__subtitle">10+ Projects</span>
      </div>

      {/* Pet photo card */}
      <div className="about__box about__box--pet">
        <img
          loading="lazy"
          src={PetImg}
          alt="my pet"
          className="about__petPhoto"
        />
      </div>
    </div>
  );
};

export default Info;
